import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'pages/styles/admin-login-page.css';
import CustomInput from 'components/custom-input';
import { isUserNameValid, isPasswordValid } from '../form-validations';
import { useLoginForm } from 'hooks/useLoginForm';
import ForgotPasswordPanel from 'components/forgot-password-panel';
import useSmallScreenSize from 'hooks/useSmallScreenSize';
import { ROUTES } from 'constants';
import Cookies from 'universal-cookie';
import { PARTNERSHIP_URL } from '../constants/index';
import { ReactComponent as Carrefour } from 'assets/images/carrefour.svg';
import { ReactComponent as CarrefourLogo } from 'assets/images/carrefour-logo.svg';
import { ReactComponent as CloseEye } from 'assets/images/passwordClosedEyeIcon.svg';
import { ReactComponent as OpenEye } from 'assets/images/passwordOpenEyeIcon.svg';
import { ReactComponent as HintIcon } from 'assets/images/hint-icon.svg';

const Admin = () => {
  const isSmallScreen = useSmallScreenSize();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const {
    userName,
    setUserName,
    password,
    setPassword,
    userNameError,
    setUserNameError,
    passwordError,
    setPasswordError,
    isLoginFormValid,
    showPassword,
    setShowPassword
  } = useLoginForm();

  const [error, setError] = useState('');
  const [loginState, setLoginState] = useState('Log in');

  const handleSubmit = async () => {
    const isValidUserName = isUserNameValid(userName, setUserNameError, true);
    const isValidPassword = isPasswordValid(password, setPasswordError, true);

    if (isValidUserName && isValidPassword) {
      try {
        setLoginState('Logging in...');

        const response = await axios.post(
          `${PARTNERSHIP_URL}/users/login`,
          {},
          {
            headers: {
              email: userName,
              password: btoa(password)
            }
          }
        );

        setLoginState('Log in');

        if (response.status === 200) {
          setUserName('');
          setPassword('');
          setShowPassword(false);
          cookies.set('token', response.data.data.token, { path: '/' });
          navigate(`${ROUTES.ADMIN_PAGE.HOME}`);
        } else if (response.status === 400) {
          setError('Invalid username or password');
          setPasswordError('');
          setUserNameError('');
          throw new Error('Login failed');
        }
      } catch (error) {
        setError(error.response.data.message);
        setLoginState('Log in');
      }
    }
  };

  return (
    <div className="loginContainer">
      <div className="login">
        <div className="carrefourLogo">
          <CarrefourLogo/>
          <Carrefour/>
        </div>
        <div className="loginForm">
          <div className="loginFormHeader">Log in to admin portal</div>
          <div className="formInputs">
            <CustomInput
              type="text"
              label="Username"
              value={userName}
              error={userNameError}
              onChange={setUserName}
              onBlur={() => isUserNameValid(userName, setUserNameError, true)}
            />
            <div id="passwordInputField">
              <CustomInput
                type={showPassword ? 'text' : 'password'}
                label="Password"
                value={password}
                error={passwordError}
                onChange={setPassword}
                onBlur={() => isPasswordValid(password, setPasswordError, true)}
              />
              <button onClick={() => setShowPassword(!showPassword)} className="eyeToggler">
                {showPassword ? (
                  <OpenEye/>
                ) : (
                  <CloseEye/>
                )}
              </button>
              {error && (
                <div className="loginError">
                  <HintIcon/>
                  <span>{error}</span>
                </div>
              )}
            </div>
          </div>
          <button className="loginButton" onClick={handleSubmit} disabled={!isLoginFormValid}>
            {loginState}
          </button>
          <div className="login-forgotPassword">
            <a
              data-bs-toggle="offcanvas"
              data-bs-target={`${isSmallScreen ? '#offcanvasBottom' : '#offcanvasWithBackdrop'}`}
              aria-controls={`${isSmallScreen ? 'offcanvasBottom' : 'offcanvasWithBackdrop'}`}
              className="blueColor">
              Forgot password?
            </a>
          </div>
        </div>
        <ForgotPasswordPanel />
      </div>
    </div>
  );
};

export default Admin;
